import { GoogleReserveParams } from '@/types/queryTypes'
import { Bookings } from '@/types/types'
import { extractDateAndTimeFromTimestamp } from '@/utils/formatDateTime'
import { LocaleDate } from '@/utils/translationService'

const googleReserveParamsToWish = (
  { timestamp, pax, room_id }: GoogleReserveParams,
  timezone?: string,
  locale?: LocaleDate
): Bookings.Wish => {
  const { date: day, time } = extractDateAndTimeFromTimestamp(timestamp, timezone, locale)

  return {
    day,
    slot: time,
    pax,
    room_id,
    waiting_list: false,
    offers: []
  }
}

export default googleReserveParamsToWish
